import { Badge } from "react-bootstrap";
import styled from "styled-components";

const CancelIcon = styled.i`
  margin-left: 5px;

  :hover {
    color: #ff322e;
  }
`;

type BubbleComponentProps = {
  onClick: () => void;
  children: React.ReactNode;
};

const BubbleComponent = ({ onClick, children }: BubbleComponentProps) => {
  return (
    <Badge
      data-testid={`bubble-item`}
      text="white"
      className="align-items-center"
    >
      {children}
      <CancelIcon
        className="fas fa-times"
        onClick={onClick}
        data-testid="cancel-icon"
      />
    </Badge>
  );
};

export default BubbleComponent;
